import classNames from 'classnames'
import React, { FC, useContext, useEffect, useRef } from 'react'
import { ConnectDragSource } from 'react-dnd'
import './SourcePreview.scss'
import { PreviewPlayerContext } from '../../../../contexts/PreviewPlayerContext'

interface IProps {
  imageUrl: string,
  setDraggable: ConnectDragSource
  styles: Record<string, string>
}

export const SourceImagePreview: FC<IProps> = ({ imageUrl, setDraggable, styles = {} }: IProps) => {
  const imageRef = useRef<HTMLImageElement>(null)
  const { setImageSource } = useContext(PreviewPlayerContext)

  useEffect(() => {
    setImageSource(imageRef?.current as (HTMLImageElement | undefined))
    return () => setImageSource(undefined)
  }, [ imageRef, setImageSource ])

  return (
    <div
      style={{ ...styles }}
      className={classNames('source-preview-img player', { 'display-none': !imageUrl })}
      draggable
    >
      <div className="source-preview-img__body media-image-preview" ref={ref => setDraggable(ref)}>
        <img src={imageUrl} alt="preview" ref={imageRef} />
      </div>
    </div>
  )
}
